import { useState } from "react";
import { Typography, Box, CircularProgress } from "@mui/material";
import { Stack } from "@mui/system";
import CancelContinueVerification from "./CancelContinueVerification";
import { ControlledInput } from "../../../../components/forms/input/ControlledInput";
import { ArrowForwardSharp } from "@mui/icons-material";
import { CancelBtn, ProceedBtn } from "../../../../components/styledComponent/Button";
import { useCrudForm } from "../../../../api/useCrudForm";
import { endpoints } from "../../../../api/endpoints";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import CustomSelect from "../../../../components/forms/select/CustomSelect";

const LockerAuthenticationForm = ({ setIsBlur, state, handleClose, handleSubmit, control, errors, reset, watch, getValues }: any) => {
    const [customerList, setCustomerList] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { add, get } = useCrudForm()
    const onSuccess: (data: any) => void = (data) => {
        setLoading(true);
        if (data?.customerId === "") delete data.customerId;
        if (data?.passCode === "") delete data.passCode;
        add({
            endpoints: endpoints.checkIn.post,
            onSuccess: (t: any) => {
                setLoading(false);
                const parsedTime = moment(t.data?.checkinTime, 'hh:mm A').toDate().getTime();
                navigate(`/visit-logs/user-verification/${t.data?.customerId}/${parsedTime}`);
                toast.success(t.message, { style: { background: '#3150A1' } })
            },
            onError: (error: any) => {
                setLoading(false);
                toast.error(error)
            },
            values: data
        })
    }

    const fetchCustomerListByLockerNumber = () => {
        if (watch('lockerNumber')) {
            get({
                endpoints: endpoints.common.getCustomersByLocker(watch('lockerNumber')),
                onSuccess: (t: any) => {
                    setCustomerList(t.data)
                },
                onError: (error: any) => {
                    setCustomerList([])
                    toast.error(error)
                }
            })
        }
    }

    return (
        <Box>
            <form onSubmit={handleSubmit(onSuccess)}>
                <Typography variant="h5" component="p" mb={6} sx={{ color: "black", fontWeight: "600", fontSize: "20px", pt: "13px" }}>Locker Authentication</Typography>
                <Stack spacing={2}>
                    <ControlledInput name="lockerNumber" label="Locker Number" control={control} errors={errors} autoFocus={true} onBlur={() => {
                        if (state?.message !== 'Driver not installed' && state?.message !== 'Device not connected' && state?.fingerTemplate) {
                            setIsBlur(true)
                        }
                        if (state?.message === 'Driver not installed' || state?.message === 'Device not connected') {
                            fetchCustomerListByLockerNumber()
                        }
                    }} />
                    {state?.message === 'Driver not installed' || state?.message === 'Device not connected' ? <>
                        <CustomSelect
                            name="customerId"
                            label="Customer"
                            control={control}
                            errors={errors?.customerId?.message}
                            values={customerList ?? []}
                        />
                        <ControlledInput name="passCode" type="password" label="Passcode" control={control} errors={errors} />
                    </> : null}
                </Stack>
                <ButtonSection state={state} handleClose={handleClose} reset={reset} loading={loading} />
            </form>
        </Box>
    );
}

type ButtonSectionPropType = {
    handleClose: () => void,
    reset: () => void,
    state: any,
    loading: boolean
}

const ButtonSection = ({ handleClose, reset, state, loading }: ButtonSectionPropType) => {
    const [open, setOpen] = useState(false);
    const handleCancel = () => {
        reset()
        setOpen(true);
    }

    return (
        <>
            <Stack direction="row" mt={3} sx={{ justifyContent: "space-between", alignItems: "center" }}>
                <CancelBtn onClick={handleCancel}>
                    <Typography sx={{ textTransform: "capitalize", fontSize: "14px" }}>Cancel</Typography>
                </CancelBtn>
                {state?.message === 'Driver not installed' || state?.message === 'Device not connected' ? <ProceedBtn type="submit">
                    {loading ?
                        <CircularProgress style={{ width: '20px', height: '20px' }} /> :
                        <>
                            <Typography sx={{ textTransform: "capitalize", fontSize: "14px" }}>Check</Typography>
                            <ArrowForwardSharp />
                        </>
                    }
                </ProceedBtn> : null}
            </Stack>
            <CancelContinueVerification open={open} setOpen={setOpen} handleParentModalClose={handleClose} />
        </>
    );
}

export default LockerAuthenticationForm;
